import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { isNil, get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import Header from 'components/Header';
import { getConfidenceThresholdAction } from 'actions/bankStatements';
import { ToastProvider } from 'components/BankStatements/ui/toast';
import styles from 'components/BankStatements/ui/css/styles.scss';
import { StatementUploadPage } from './StatementUploadPage';
import StatementReviewPage from './StatementReviewPage';

import './index.css';

const BankStatement = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState('upload');
  const [selectedStatementId, setSelectedStatementId] = useState(null);
  const data = useSelector(state => get(state, 'workflow.data.data') || get(state, 'workflow.state.data'));
  const bankProcessorKey = useSelector((state) => get(state, 'workflow.data.data.bankProcessorKey') || get(state, 'workflow.state.data.bankProcessorKey'));
  const applicationId = useSelector((state) => get(state, 'workflow.attributes.entityId'));
  const navigate = useNavigate();
  // Application context
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');

  useEffect(() => {
    if (!key) {
      navigate('/');
    } else if (isNil(data)) {
      navigate(`/applications/fsl/checkin?key=${key}`);
    } else {
      dispatch(getConfidenceThresholdAction({ bankProcessorKey }));
    }

  }, []);

  const handleStatementSelect = (statementId) => {
    setSelectedStatementId(statementId);
    console.log('statementId', statementId);
    setCurrentPage('review');
  };

  const handleBackToUpload = () => {
    setCurrentPage('upload');
    setSelectedStatementId(null);
  };

  return (
    <ToastProvider>
      <div className={cn('use-tailwind', styles['bank-statement-container'])}>
        <Header />

        {currentPage === 'upload' && (
          <StatementUploadPage
            applicationId={applicationId}
            bankProcessorKey={bankProcessorKey}
            onStatementSelect={handleStatementSelect}
          />
        )}

        {currentPage === 'review' && selectedStatementId !== null && (
          <StatementReviewPage
            applicationId={applicationId}
            statementId={selectedStatementId}
            onBack={handleBackToUpload}
            bankProcessorKey={bankProcessorKey}
          />
        )}
      </div>
    </ToastProvider>
  );
};

export default BankStatement;
